<template>
     <div>
    <!-- Page Header -->
    <div class="row">
      <div class="col-12 col-sm-6 text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">All Requirements
        </span>
        <h3 class="page-title">Requirements</h3>
      </div>
      <div class="col-12 col-sm-6 d-flex align-items-center">
        <div class="mx-auto ml-sm-auto mr-sm-0">
          <CButton block color="info">Add</CButton>
        </div>
      </div>
    </div>
    <!-- End Page Header -->

    <!-- Datatable -->
    <div id="people" class="dataTables_wrapper no-footer my-5">
      <v-client-table :data="Object.values(requirementsList)" :columns="columns" class="text-center" :options="options">
        <div slot="serial" slot-scope="props">
          {{ props.index }}
        </div>
        <div slot="logo" slot-scope="props">
          <img v-lazy="getProfilePhoto(props.row.logo)" class="border" width="80px">
        </div>
        <div slot="action" slot-scope="props">
          <CButtonGroup size="sm" class="mx-1">
            <CButton color="secondary" >
              <font-awesome-icon icon="edit"/>
            </CButton>
            <CButton color="secondary" >
              <font-awesome-icon icon="trash-alt"/>
            </CButton>
          </CButtonGroup>
        </div>
      </v-client-table>
    </div>
    <!-- End Datatable -->

    
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import {REQUIREMENT_LIST} from "@/core/services/store/module/requirements";
export default {
    name:"Requirements",
    data(){
        return{
            columns: ['IP', 'Product', 'Details', 'action'],
            options: {
                headings: {
                    serial: '#',
                    name: 'Brand Name',
                    logo: 'Brand Logo'
                },
                sortable: ['Product'],
                filterable: ['Product', 'IP']
            }
        }
    },
    computed:{
        ...mapGetters(['requirementsList'])
    },
    created(){
      this.$store.dispatch(REQUIREMENT_LIST)
    }
}
</script>